import CityPageTemplate from './CityPageTemplate';

export default function KissimmeePage() {
  return (
    <CityPageTemplate
      city="Kissimmee"
      county="Osceola"
      slug="kissimmee"
      zipCodes={['34741', '34744']}
      neighborhoods={['Downtown Kissimmee', 'Celebration', 'Lakefront Park area', 'Osceola Parkway corridor', 'Buenaventura Lakes']}
      localContext="Gateway to Central Florida's tourism corridor, Kissimmee is home to diverse neighborhoods from historic Downtown to the master-planned community of Celebration."
      metaDescription="Professional residential and commercial cleaning services in Kissimmee, FL. Serving ZIP codes 34741 & 34744. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
